import axios from "axios";
import { Base_URL } from "../url";

export const fetchRoles = async () => {
  try {
    const response = await axios.get(`${Base_URL}/RoleMaster/GetAllRoles`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching roles!";
  }
};

export const downloadRolesExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/RoleMaster/DownloadRolesExcel`,
      null, // Empty body for POST request
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading roles data!";
  }
};